import HeroSection from "@components/sections/HeroSection";
import StatsBar from "@components/sections/StatsBar";
import Philosophy from "@components/sections/Philosophy";
import CatalogPreview from "@components/sections/CatalogPreview";
import WhyUs from "@components/sections/WhyUs";
import HowWeWork from "@components/sections/HowWeWork";
import Materials from "@components/sections/Materials";
import Testimonials from "@components/sections/Testimonials";
import ContactSection from "@components/sections/ContactSection";
import Footer from "@components/layout/Footer";
import SEOMeta from "@components/seo/SEOMeta";
import { LocalBusinessSchema, BreadcrumbSchema } from "@components/seo/SchemaOrg";

export default function HomePage() {
  return (
    <>
      <SEOMeta
        title="Гранітні пам'ятники Ямпіль — Власне виробництво"
        description="Виготовлення та встановлення гранітних пам'ятників на могилу у Ямполі. Власне виробництво, 3D-макет безкоштовно, доставка по Вінницькій області."
        canonicalPath="/"
      />
      <LocalBusinessSchema />
      <BreadcrumbSchema items={[{ name: "Головна", path: "/" }]} />
      <HeroSection />
      <StatsBar />
      <Philosophy />
      <CatalogPreview />
      <WhyUs />
      <HowWeWork />
      <Materials />
      <Testimonials />
      <ContactSection />
      <Footer />
    </>
  );
}
